import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef } from 'react';
const useBodyScrollLock = (trigger, lockHtmlTag = true) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current === null) {
            clearAllBodyScrollLocks();
            if (lockHtmlTag) {
                window.document.documentElement.style.overflow = '';
            }
            return;
        }
        if (trigger === true) {
            disableBodyScroll(ref.current);
            if (lockHtmlTag) {
                window.document.documentElement.style.overflow = 'hidden';
            }
            else {
                window.document.documentElement.style.overflow = 'visible';
            }
        }
        else {
            enableBodyScroll(ref.current);
            if (lockHtmlTag) {
                window.document.documentElement.style.overflow = '';
            }
        }
        return () => {
            if (ref.current !== null) {
                enableBodyScroll(ref.current);
                if (lockHtmlTag) {
                    window.document.documentElement.style.overflow = '';
                }
            }
        };
    }, [trigger]);
    return ref;
};
export default useBodyScrollLock;
